import styles from "./styles/InitialLoading.module.css";
function InitialLoading({ position = null }) {
  return (
    <div
      className={`${styles.roller} ${position ? styles.blackBg : ""}`}
      style={
        position
          ? {
              position,
            }
          : {}
      }
    >
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
}

export default InitialLoading;
